import { AbstractEntityMapper } from '@pf/shared-services';
import {
    PutAwayCreate,
    PutAwayDto,
    PutAwayRead,
    PutAwaySearchParams,
} from '../../entities/put-away.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { PutAwayMetadataMap } from './put-away.mapping-profile';

@Injectable()
export class PutAwayMapper extends AbstractEntityMapper<
    PutAwayRead,
    PutAwayCreate,
    PutAwayDto,
    PutAwaySearchParams
> {
    constructor() {
        super(PutAwayDto, PlatformWmsMapper, PutAwayMetadataMap.symbols);
    }
}
